import React from "react";
import { useTranslation } from "react-i18next";
import pen from "../../assets/images/pen.svg";
import { GVModalTemplate } from "./index";

const CompanyModal = ({ open, handleClose, formikProps, companyStyles }) => {
  const { t } = useTranslation();

  return (
    <GVModalTemplate
      open={open}
      handleClose={handleClose}
      formikProps={formikProps}
      generationVariablesList={companyStyles}
      fieldName="company_id"
      modalTitle={t("Brand-identity", "Identité de marque")}
      nameAndPronoun={t("the-brand-identity", "l'identité de marque")}
      modalIcon={pen}
      modalDescription={t(
        "company-website-description",
        "Fournissez davantage de contexte sur votre site web ou votre entreprise afin de personnaliser le contenu généré et de l'adapter à votre public cible."
      )}
      noSelectionText={t(
        "No-company-website-selected",
        "Aucun(e) entreprise/site web sélectionné(e)"
      )}
      createLink="/profile?tab=manage-variables"
      createText="Créer une nouvelle identité de marque"
    />
  );
};

export default CompanyModal;
